import { Truck } from "lucide-react";

const addBusinessDays = (from, n) => {
  const d = new Date(from);
  let left = n;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
  }
  return d;
};
const fmt = (d) => d.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });

/** Fourchette indicative en Point Relais France (3 à 5 jours ouvrés après la commande). */
export function DeliveryEstimate() {
  const now = new Date();
  return (
    <p data-testid="product-delivery-estimate" className="mt-4 flex items-center gap-2 text-sm text-[var(--parchment)]/90">
      <Truck className="h-4 w-4 shrink-0 text-[var(--gold)]" />
      <span>Commandez aujourd'hui : livraison estimée en Point Relais entre le <b className="text-[var(--gold-soft)]">{fmt(addBusinessDays(now, 3))}</b> et le <b className="text-[var(--gold-soft)]">{fmt(addBusinessDays(now, 5))}</b> (France).</span>
    </p>
  );
}
